module.exports = "<vue-tags-input\n  v-model=\"tag\"\n  :tags=\"tags\"\n  @tags-changed=\"newTags => tags = newTags\"\n  @before-adding-tag=\"checkTag\"\n/>\n"